module.exports = __webpack_public_path__ + "static/media/blank.4dc32a6f.png";